import React from "react";
import { Button } from "./ui/button";
import { Smartphone, MapPin, Shield } from "lucide-react";

import { mockData } from "../mock";

const HeroSection = () => {
  const { links } = mockData.company;

  return (
    <section className="min-h-screen flex items-center justify-center px-4 py-8 relative overflow-hidden">
      {/* Background gradient effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-yellow-500/10 via-orange-500/5 to-transparent"></div>
      
      <div className="container mx-auto grid lg:grid-cols-2 gap-12 items-center relative z-10">
        {/* Left Content */}
        <div className="text-center lg:text-left space-y-8">
          {/* Logo */}
          <div className="flex justify-center lg:justify-start mb-8">
            <div className="w-24 h-24 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full flex items-center justify-center shadow-lg shadow-yellow-500/25">
              <MapPin className="w-12 h-12 text-black" />
            </div>
          </div>
          
          <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight">
            Rastreie seus <span className="bg-gradient-to-r from-yellow-400 to-orange-500 bg-clip-text text-transparent">veículos</span> de onde estiver!
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-300 leading-relaxed">
            Segurança, tecnologia e praticidade por apenas <span className="text-yellow-400 font-semibold">R$50/mês</span>.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
            <Button 
              size="lg"
              className="bg-gradient-to-r from-yellow-400 to-orange-500 text-black font-semibold hover:from-yellow-500 hover:to-orange-600 transition-all duration-300 shadow-lg shadow-yellow-500/25 hover:shadow-yellow-500/40 transform hover:scale-105"
              asChild
            >
              <a href={links.whatsapp} target="_blank" rel="noopener noreferrer">
                Quero Rastrear Agora
              </a>
            </Button>
            
            <Button 
              variant="outline" 
              size="lg"
              className="border-yellow-400 text-yellow-400 hover:bg-yellow-400 hover:text-black transition-all duration-300"
              asChild
            >
              <a href={links.demo} target="_blank" rel="noopener noreferrer">
                Ver Demonstração
              </a>
            </Button>
          </div>
          
          {/* Features highlights */}
          <div className="flex flex-wrap gap-6 justify-center lg:justify-start mt-12">
            <div className="flex items-center gap-2 text-gray-300">
              <Shield className="w-5 h-5 text-yellow-400" />
              <span>Máxima Segurança</span>
            </div>
            <div className="flex items-center gap-2 text-gray-300">
              <MapPin className="w-5 h-5 text-yellow-400" />
              <span>Tempo Real</span>
            </div>
            <div className="flex items-center gap-2 text-gray-300">
              <Smartphone className="w-5 h-5 text-yellow-400" />
              <span>App Mobile</span>
            </div>
          </div>
        </div>
        
        {/* Right Content - App Mockup */}
        <div className="flex justify-center lg:justify-end">
          <div className="relative">
            {/* Phone mockup */}
            <div className="w-80 h-96 bg-gradient-to-b from-gray-800 to-gray-900 rounded-3xl p-6 shadow-2xl shadow-yellow-500/20 border border-gray-700">
              {/* Phone screen */}
              <div className="w-full h-full bg-black rounded-2xl p-4 flex flex-col">
                {/* Status bar */}
                <div className="flex justify-between items-center text-white text-sm mb-4">
                  <span>9:41</span>
                  <span>100%</span>
                </div>
                
                {/* App header */}
                <div className="text-center mb-6">
                  <h3 className="text-yellow-400 font-bold text-lg">Eletron Rastreamento</h3>
                </div>
                
                {/* Map area simulation */}
                <div className="flex-1 bg-gradient-to-br from-green-900/30 to-blue-900/30 rounded-lg p-4 relative">
                  <div className="absolute top-4 left-4">
                    <div className="w-3 h-3 bg-yellow-400 rounded-full animate-pulse"></div>
                  </div>
                  <div className="absolute bottom-4 right-4">
                    <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                  </div>
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                    <MapPin className="w-8 h-8 text-yellow-400" />
                  </div>
                </div>
                
                {/* Vehicle info */}
                <div className="mt-4 bg-gray-800 rounded-lg p-3">
                  <p className="text-white text-sm font-semibold">Veículo ABC-1234</p>
                  <p className="text-gray-400 text-xs">Última atualização: agora</p>
                </div>
              </div>
            </div>
            
            {/* Floating elements */}
            <div className="absolute -top-4 -right-4 w-8 h-8 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full animate-bounce"></div>
            <div className="absolute -bottom-4 -left-4 w-6 h-6 bg-gradient-to-r from-orange-500 to-yellow-400 rounded-full animate-pulse"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;